import axios from 'axios';
import * as yup from 'yup';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup.object()
});
export async function getPatientByReportId({ reportId, }) {
    const response = await axios.post('/api/tasks/getPatientByReportId', {
        report_id: reportId,
    });
    const { data } = await responseSchema.validate(response.data);
    return {
        data,
    };
}
